import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxStripeModule } from 'ngx-stripe';
import { SharedModule } from '../../../shared/modules/shared/shared.module';
import { LimitedDataBannerComponent } from '../components/limited-data-banner/limited-data-banner.component';
import { ManageSubscriptionComponent } from '../components/manage-subscription/manage-subscription.component';
import { RestrictionDialogComponent } from '../dialogs/restriction-dialog/restriction-dialog.component';
import { UpgradeSubscriptionDialogComponent } from '../dialogs/upgrade-subscription-dialog/upgrade-subscription-dialog.component';

const declarations = [
  LimitedDataBannerComponent,
  ManageSubscriptionComponent,
  RestrictionDialogComponent,
  UpgradeSubscriptionDialogComponent,
];

@NgModule({
  imports: [CommonModule, SharedModule, NgxStripeModule, RouterModule],
  declarations,
  exports: declarations,
})
export class SubscriptionModule {}
